import AccessControl from '@/components/AccessControl';
import { Stack } from '@/components/custom-components'
import { buttonVariants } from '@/components/shadcn/button.tsx'

import { historyColumns } from '@/components/creative-analysis/history/columns'
import { DataTable } from '@/components/shadcn/data-table'
import { useElementSize } from '@/hooks/useElementSize'
import { cn } from '@/lib/utils'
import { ArrowLeft, Plus } from '@mynaui/icons-react'
import { Link, createFileRoute } from '@tanstack/react-router'
import { useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { CreativeOSPages } from '@/_shared/subscriptionPlans';

type SearchParams = {
  sideBarOpen?: boolean
}

export const Route = createFileRoute('/feeds/creative-toolkit/creative-analysis/history/')({
  component: All,
  validateSearch: (search: Record<string, unknown>): SearchParams => {
    const sideBarOpen = search?.sideBarOpen as boolean

    return {
      sideBarOpen,
    }
  },
})

function All() {
  const [squareRef] = useElementSize()

  const navigate = useNavigate();

  useEffect(() => {
    navigate({ to: '/funnel-analyzer' });
  }, []);

  return (
    <>
      <AccessControl page={CreativeOSPages.CREATIVE_TOOLKIT_COPY_GRADER}>

      <Stack ref={squareRef} className="gap-3 lg:gap-6">
        <Stack className="gap-3 lg:gap-8">
          <Stack className="gap-3 lg:gap-6">
            <div>
              <Link
                className={cn(buttonVariants({ variant: 'secondary', size: 'sm' }))}
                to={'/feeds/creative-toolkit/creative-analysis'}
              >
                <ArrowLeft /> Back
              </Link>
            </div>
            <div className={'flex justify-between gap-5 items-center'}>
              <div className={''}>
                <h1 className={'text-lg lg:text-2xl font-semibold'}>Your Analysis History</h1>
                <p className={'text-lg lg:text-base text-thememutedforeground mt-2'}>
                  See all your recent analysis history.
                </p>
              </div>
              <div>
                <Link
                  className={cn(buttonVariants({ variant: 'destructivePurple', size: 'sm' }))}
                  to={'/feeds/creative-toolkit/creative-analysis'}
                >
                  <Plus /> Create Analysis
                </Link>
              </div>
            </div>
          </Stack>
        </Stack>
        <div>
          <DataTable data={[]} columns={historyColumns} />
        </div>
      </Stack>
      </AccessControl>
    </>
  )
}
